import { InnerBlocks } from '@wordpress/block-editor';

/**
 * The card wrapper and the pin are both built by render.php, so the saved
 * markup is the author's content and nothing else. Keeping the chrome on the
 * server means the pin artwork can change later without invalidating every
 * note already published.
 */
export default function Save() {
  return <InnerBlocks.Content />;
}
